import base_speedTest_component from '#BASE/components/speedTest/speedTest.component';
import websiteInfoUtil from 'BASE/common/util/util.websiteInfo';
import logoComponent from 'TY/views/Logo.vue';
import login_footer_component from 'TY/views/LoginFooter.vue';
import Clipboard from 'clipboard';
import dialogPlugin from 'BASE/plugins/dialogPlugin';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { browser } from 'BASE/common/util/util.browser';
import IEAlertComponent from 'TY/views/IEAlert.vue';

export default {
    name: 'speedtest',
    mixins: [base_speedTest_component, websiteInfoUtil],
    data: function () {
        return {
            minHeight: 600,
            QrcodeValue: "",
            QrcodeOptions: {
                width: 112,
                margin: 1
            },
            goLinkPage: "/Login",
        };
    },
    components: {
        logo: logoComponent,
        login_footer_component,
        Clipboard,
        dialogPlugin,
        qrcode: VueQrcode,
        IEAlertComponent,
    },
    methods: {
        resizeContent() {
            let _footer = $("footer").outerHeight();
            if(typeof _footer === 'undefined')
                _footer = 0;

            this.minHeight = $(window).height() - _footer;
        },
        copy() {
            let _this = this;
            var clipboard = new Clipboard('.copyUrl')
            clipboard.on('success', e => {
                console.log('复制成功')
                _this.$dialog.warning('复制成功')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                console.log('该浏览器不支持自动复制')
                clipboard.destroy()
            });
        },
    },
    mounted() {
        if (browser.isIE)
            this.$refs.ieAlert.showDialog();
            
        //先執行一次變更內容區最小高度，綁定視窗變更事件
        this.resizeContent();
        window.onresize = () => this.resizeContent();
    }
};